import { RadioGroup } from '@/components/RadioGroup';
import {
    ECondition,
    selectVehicleCondition,
    setIsVehicleRegistrationKnown,
    setVehicleCondition,
} from '@/context/borrower';
import { useAppDispatch, useAppSelector } from '@/context/storeHooks';
import { useFieldCopy } from '@/copy';
import { userFacingAssetTitle } from '@/utils/userFacingAssetTitle';

export interface IProps {
    baseId: string;
    showErrors: boolean;
}

export const testId = 'VehicleCondition';

export function VehicleCondition({ baseId, showErrors }: IProps): JSX.Element {
    // ***** Redux *****
    const fields = useFieldCopy();
    const currentState = useAppSelector(selectVehicleCondition);
    const dispatch = useAppDispatch();
    const assetTitle = userFacingAssetTitle();

    // ***** Event Handlers *****
    function handleChange(value: string | boolean | undefined): void {
        if (value === ECondition.NEW) {
            dispatch(setIsVehicleRegistrationKnown(false));
        } else {
            dispatch(setIsVehicleRegistrationKnown(true));
        }
        dispatch(setVehicleCondition(value as ECondition));
    }

    // ***** Render *****
    const options = [
        {
            label: 'New',
            value: ECondition.NEW,
            id: `${baseId}-button-VehicleCondition-new`,
        },
        {
            label: 'Used',
            value: ECondition.USED,
            id: `${baseId}-button-VehicleCondition-used`,
        },
    ];
    return (
        <div data-testid={testId}>
            <RadioGroup
                title={fields.vehicleCondition.replace(
                    '{asset}',
                    assetTitle.toLowerCase()
                )}
                showErrors={showErrors}
                onChange={handleChange}
                options={options}
                value={currentState}
                tooltipContent={`If the ${assetTitle.toLowerCase()} is a "Demo" then select "Used"`}
            />
        </div>
    );
}
